type T = React.SVGProps<SVGSVGElement>;

export const FilledHeart = (props: T) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.0029 4.00001C20.8388 3.99801 19.6902 4.2677 18.6486 4.78762C17.607 5.30755 16.7011 6.06336 16.0029 6.99494C15.0574 5.73687 13.7402 4.808 12.2376 4.33976C10.7351 3.87153 9.12341 3.88764 7.63055 4.38582C6.1377 4.884 4.8393 5.83901 3.91909 7.11574C2.99888 8.39246 2.50346 9.92623 2.50293 11.5C2.50293 20.4829 14.983 27.575 15.5143 27.8725C15.6636 27.9561 15.8318 28 16.0029 28C16.174 28 16.3423 27.9561 16.4916 27.8725C18.7869 26.5282 20.9412 24.9563 22.9219 23.1808C27.2887 19.2506 29.5029 15.3206 29.5029 11.5C29.5007 9.51158 28.7098 7.60523 27.3037 6.1992C25.8977 4.79316 23.9914 4.00226 22.0029 4.00001Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const FilledPicture = (props: T) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.58005 19.0103L2.56005 19.0303C2.29005 18.4403 2.12005 17.7703 2.05005 17.0303C2.12005 17.7603 2.31005 18.4203 2.58005 19.0103Z"
        fill="currentColor"
      />
      <path
        d="M9.00036 10.3801C10.3148 10.3801 11.3804 9.31456 11.3804 8.00012C11.3804 6.68568 10.3148 5.62012 9.00036 5.62012C7.68592 5.62012 6.62036 6.68568 6.62036 8.00012C6.62036 9.31456 7.68592 10.3801 9.00036 10.3801Z"
        fill="currentColor"
      />
      <path
        d="M16.1902 2H7.81024C4.17024 2 2.00024 4.17 2.00024 7.81V16.19C2.00024 17.28 2.19024 18.23 2.56024 19.03C3.42024 20.93 5.26024 22 7.81024 22H16.1902C19.8302 22 22.0002 19.83 22.0002 16.19V13.9V7.81C22.0002 4.17 19.8302 2 16.1902 2ZM20.3702 12.5C19.5902 11.83 18.3302 11.83 17.5502 12.5L13.3902 16.07C12.6102 16.74 11.3502 16.74 10.5702 16.07L10.2302 15.79C9.52024 15.17 8.39024 15.11 7.59024 15.65L3.85024 18.16C3.63024 17.6 3.50024 16.95 3.50024 16.19V7.81C3.50024 4.99 4.99024 3.5 7.81024 3.5H16.1902C19.0102 3.5 20.5002 4.99 20.5002 7.81V12.61L20.3702 12.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FilledHashtag = (props: T) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.8297 8.6998L15.2997 4.1698C14.3497 3.2198 13.0397 2.7098 11.6997 2.7798L6.69973 3.0198C4.69973 3.1098 3.10973 4.6998 3.00973 6.6898L2.76973 11.6898C2.70973 13.0298 3.20973 14.3398 4.15973 15.2898L8.68973 19.8198C10.5497 21.6798 13.5697 21.6798 15.4397 19.8198L19.8297 15.4298C21.6997 13.5798 21.6997 10.5598 19.8297 8.6998ZM9.49973 12.3798C7.90973 12.3798 6.61973 11.0898 6.61973 9.4998C6.61973 7.9098 7.90973 6.6198 9.49973 6.6198C11.0897 6.6198 12.3797 7.9098 12.3797 9.4998C12.3797 11.0898 11.0897 12.3798 9.49973 12.3798Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const FilledRemoveImage = (props: T) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.6" y="2" width="22" height="22" rx="12" fill="white" />
      <path
        d="M12.5 0.908203C15.6826 0.908203 18.7348 2.17249 20.9853 4.42292C23.2357 6.67336 24.5 9.72561 24.5 12.9082C24.5 16.0908 23.2357 19.143 20.9853 21.3935C18.7348 23.6439 15.6826 24.9082 12.5 24.9082C9.3174 24.9082 6.26516 23.6439 4.01472 21.3935C1.76428 19.143 0.5 16.0908 0.5 12.9082C0.5 9.72561 1.76428 6.67336 4.01472 4.42292C6.26516 2.17249 9.3174 0.908203 12.5 0.908203V0.908203ZM12.5 11.4528L9.71257 8.66535C9.51957 8.47234 9.2578 8.36392 8.98486 8.36392C8.71191 8.36392 8.45014 8.47234 8.25714 8.66535C8.06414 8.85835 7.95571 9.12011 7.95571 9.39306C7.95571 9.66601 8.06414 9.92777 8.25714 10.1208L11.0446 12.9082L8.25714 15.6956C8.16158 15.7912 8.08577 15.9046 8.03405 16.0295C7.98233 16.1544 7.95571 16.2882 7.95571 16.4233C7.95571 16.5585 7.98233 16.6923 8.03405 16.8172C8.08577 16.942 8.16158 17.0555 8.25714 17.1511C8.35271 17.2466 8.46616 17.3224 8.59102 17.3742C8.71588 17.4259 8.84971 17.4525 8.98486 17.4525C9.12001 17.4525 9.25383 17.4259 9.37869 17.3742C9.50355 17.3224 9.61701 17.2466 9.71257 17.1511L12.5 14.3636L15.2874 17.1511C15.383 17.2466 15.4964 17.3224 15.6213 17.3742C15.7462 17.4259 15.88 17.4525 16.0151 17.4525C16.1503 17.4525 16.2841 17.4259 16.409 17.3742C16.5338 17.3224 16.6473 17.2466 16.7429 17.1511C16.8384 17.0555 16.9142 16.942 16.9659 16.8172C17.0177 16.6923 17.0443 16.5585 17.0443 16.4233C17.0443 16.2882 17.0177 16.1544 16.9659 16.0295C16.9142 15.9046 16.8384 15.7912 16.7429 15.6956L13.9554 12.9082L16.7429 10.1208C16.8384 10.0252 16.9142 9.91176 16.9659 9.7869C17.0177 9.66204 17.0443 9.52821 17.0443 9.39306C17.0443 9.25791 17.0177 9.12409 16.9659 8.99922C16.9142 8.87436 16.8384 8.76091 16.7429 8.66535C16.6473 8.56978 16.5338 8.49398 16.409 8.44226C16.2841 8.39054 16.1503 8.36392 16.0151 8.36392C15.88 8.36392 15.7462 8.39054 15.6213 8.44226C15.4964 8.49398 15.383 8.56978 15.2874 8.66535L12.5 11.4528Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const FilledArrowLeft = (_props: T) => {
  return (
    <svg
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {..._props}
    >
      <path
        d="M6.2782 1.5575L5.2207 0.5L0.720703 5L5.2207 9.5L6.2782 8.4425L2.8432 5L6.2782 1.5575Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const FilledChecked = (_props: T) => {
  return (
    <svg
      width={15}
      height={10}
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {..._props}
    >
      <path
        d="M13.1875 1.06274L5.3125 8.93739L1.375 5.00025"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FilledVectorLeft = (_props: T) => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {..._props}
    >
      <path
        d="M13.6654 6.16658H3.5237L8.18203 1.50825L6.9987 0.333252L0.332031 6.99992L6.9987 13.6666L8.1737 12.4916L3.5237 7.83325H13.6654V6.16658Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FilledDot = (_props: T) => (
  <svg
    width="6"
    height="6"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="3.5" cy="3.5" r="3" fill="currentColor" />
  </svg>
);

export const FilledBadgeTrickIcon = (_props: T) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <path
      d="M21.1746 9.63895C20.8209 9.27017 20.4553 8.88895 20.3171 8.55487C20.1901 8.24799 20.1824 7.73969 20.175 7.24805C20.1612 6.33316 20.1455 5.29623 19.4247 4.57535C18.7038 3.85446 17.6668 3.83881 16.752 3.82498C16.2603 3.81757 15.752 3.80988 15.4451 3.68289C15.1111 3.54474 14.7298 3.17908 14.3611 2.82541C13.7133 2.20413 12.979 1.5 12 1.5C11.021 1.5 10.2868 2.20413 9.63895 2.82541C9.27017 3.17908 8.88895 3.54474 8.55487 3.68289C8.24799 3.80988 7.73969 3.81757 7.24805 3.82498C6.33316 3.83881 5.29623 3.85446 4.57535 4.57535C3.85446 5.29623 3.83881 6.33316 3.82498 7.24805C3.81757 7.73969 3.80988 8.24798 3.68289 8.55487C3.54474 8.88885 3.17908 9.27017 2.82541 9.63895C2.20413 10.2867 1.5 11.021 1.5 12C1.5 12.979 2.20413 13.7132 2.82541 14.3611C3.17908 14.7298 3.54474 15.1111 3.68289 15.4451C3.80988 15.752 3.81757 16.2603 3.82498 16.752C3.83881 17.6668 3.85446 18.7038 4.57535 19.4247C5.29623 20.1455 6.33316 20.1612 7.24805 20.175C7.73969 20.1824 8.24798 20.1901 8.55487 20.3171C8.88885 20.4553 9.27017 20.8209 9.63895 21.1746C10.2867 21.7959 11.021 22.5 12 22.5C12.979 22.5 13.7132 21.7959 14.3611 21.1746C14.7298 20.8209 15.1111 20.4553 15.4451 20.3171C15.752 20.1901 16.2603 20.1824 16.752 20.175C17.6668 20.1612 18.7038 20.1455 19.4247 19.4247C20.1455 18.7038 20.1612 17.6668 20.175 16.752C20.1824 16.2603 20.1901 15.752 20.3171 15.4451C20.4553 15.1111 20.8209 14.7298 21.1746 14.3611C21.7959 13.7133 22.5 12.979 22.5 12C22.5 11.021 21.7959 10.2868 21.1746 9.63895ZM16.6428 10.2925L11.1428 15.5425C11.0033 15.6757 10.8178 15.75 10.625 15.75C10.4321 15.75 10.2467 15.6757 10.1071 15.5425L7.35718 12.9175C7.28589 12.8496 7.22869 12.7682 7.18886 12.6781C7.14902 12.588 7.12733 12.4909 7.12502 12.3924C7.1227 12.2939 7.13981 12.196 7.17537 12.1041C7.21093 12.0122 7.26425 11.9283 7.33226 11.857C7.40028 11.7857 7.48167 11.7286 7.57178 11.6888C7.6619 11.649 7.75897 11.6273 7.85746 11.625C7.95595 11.6227 8.05392 11.6399 8.14578 11.6755C8.23764 11.7111 8.32158 11.7644 8.39282 11.8325L10.625 13.9632L15.6072 9.20746C15.6784 9.13942 15.7624 9.08607 15.8542 9.05048C15.9461 9.01489 16.0441 8.99774 16.1425 9.00002C16.241 9.0023 16.3381 9.02395 16.4282 9.06376C16.5183 9.10356 16.5997 9.16073 16.6677 9.23199C16.7358 9.30325 16.7891 9.38722 16.8246 9.47909C16.8602 9.57096 16.8773 9.66894 16.875 9.76743C16.8727 9.86591 16.851 9.96298 16.8111 10.0531C16.7713 10.1432 16.7141 10.2246 16.6428 10.2925Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledCheckCircle = (_props: T) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 9.34783 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34783 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34783 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34783 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12ZM11.4293 16.28L17.1867 9.08267L16.1467 8.25067L11.2373 14.3853L7.76 11.488L6.90667 12.512L11.4293 16.2813V16.28Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledCloseCircle = (_props: T) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <path
      d="M12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2ZM12 10.7871L9.67714 8.46429C9.51631 8.30345 9.29817 8.2131 9.07071 8.2131C8.84326 8.2131 8.62512 8.30345 8.46429 8.46429C8.30345 8.62512 8.2131 8.84326 8.2131 9.07071C8.2131 9.29817 8.30345 9.51631 8.46429 9.67714L10.7871 12L8.46429 14.3229C8.38465 14.4025 8.32148 14.497 8.27838 14.6011C8.23528 14.7051 8.2131 14.8167 8.2131 14.9293C8.2131 15.0419 8.23528 15.1534 8.27838 15.2575C8.32148 15.3615 8.38465 15.4561 8.46429 15.5357C8.54392 15.6154 8.63847 15.6785 8.74252 15.7216C8.84657 15.7647 8.95809 15.7869 9.07071 15.7869C9.18334 15.7869 9.29486 15.7647 9.39891 15.7216C9.50296 15.6785 9.59751 15.6154 9.67714 15.5357L12 13.2129L14.3229 15.5357C14.4025 15.6154 14.497 15.6785 14.6011 15.7216C14.7051 15.7647 14.8167 15.7869 14.9293 15.7869C15.0419 15.7869 15.1534 15.7647 15.2575 15.7216C15.3615 15.6785 15.4561 15.6154 15.5357 15.5357C15.6154 15.4561 15.6785 15.3615 15.7216 15.2575C15.7647 15.1534 15.7869 15.0419 15.7869 14.9293C15.7869 14.8167 15.7647 14.7051 15.7216 14.6011C15.6785 14.497 15.6154 14.4025 15.5357 14.3229L13.2129 12L15.5357 9.67714C15.6154 9.59751 15.6785 9.50296 15.7216 9.39891C15.7647 9.29486 15.7869 9.18334 15.7869 9.07071C15.7869 8.95809 15.7647 8.84657 15.7216 8.74252C15.6785 8.63847 15.6154 8.54392 15.5357 8.46429C15.4561 8.38465 15.3615 8.32148 15.2575 8.27838C15.1534 8.23528 15.0419 8.2131 14.9293 8.2131C14.8167 8.2131 14.7051 8.23528 14.6011 8.27838C14.497 8.32148 14.4025 8.38465 14.3229 8.46429L12 10.7871Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledCheckCircleInnerWhite = (_props: T) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <g clipPath="url(#clip0_2775_147462)">
      <rect width="15" height="15" rx="7.5" fill="white" />
      <path
        d="M7.5 0C6.01664 0 4.56659 0.439867 3.33323 1.26398C2.09986 2.08809 1.13856 3.25943 0.570907 4.62987C0.00324963 6.00032 -0.145275 7.50832 0.144114 8.96318C0.433503 10.418 1.14781 11.7544 2.1967 12.8033C3.2456 13.8522 4.58197 14.5665 6.03682 14.8559C7.49168 15.1453 8.99968 14.9968 10.3701 14.4291C11.7406 13.8614 12.9119 12.9001 13.736 11.6668C14.5601 10.4334 15 8.98336 15 7.5C14.9977 5.51158 14.2068 3.60526 12.8008 2.19924C11.3947 0.793212 9.48842 0.00229818 7.5 0V0ZM11.072 6.18671L6.84082 10.2252C6.73324 10.3275 6.59043 10.3846 6.44193 10.3846C6.29344 10.3846 6.15063 10.3275 6.04305 10.2252L3.92804 8.20594C3.81754 8.1001 3.75357 7.95472 3.75019 7.80175C3.7468 7.64877 3.80427 7.50071 3.90997 7.39008C4.01568 7.27945 4.16097 7.2153 4.31394 7.21171C4.46691 7.20813 4.61505 7.26542 4.72581 7.37098L6.44193 9.00991L10.2742 5.35175C10.385 5.24619 10.5331 5.1889 10.6861 5.19248C10.839 5.19607 10.9843 5.26022 11.09 5.37085C11.1957 5.48148 11.2532 5.62954 11.2498 5.78252C11.2464 5.93549 11.1825 6.08087 11.072 6.18671V6.18671Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2775_147462">
        <rect width="15" height="15" rx="7.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FilledCloseCircleInnerWhite = (_props: T) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <g clipPath="url(#clip0_2775_147469)">
      <rect width="15" height="15" rx="7.5" fill="white" />
      <path
        d="M7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0ZM7.5 6.59036L5.75786 4.84821C5.63723 4.72759 5.47363 4.65982 5.30304 4.65982C5.13244 4.65982 4.96884 4.72759 4.84821 4.84821C4.72759 4.96884 4.65982 5.13244 4.65982 5.30304C4.65982 5.47363 4.72759 5.63723 4.84821 5.75786L6.59036 7.5L4.84821 9.24214C4.78849 9.30187 4.74111 9.37278 4.70878 9.45082C4.67646 9.52886 4.65982 9.6125 4.65982 9.69696C4.65982 9.78143 4.67646 9.86507 4.70878 9.94311C4.74111 10.0212 4.78849 10.0921 4.84821 10.1518C4.90794 10.2115 4.97885 10.2589 5.05689 10.2912C5.13493 10.3235 5.21857 10.3402 5.30304 10.3402C5.3875 10.3402 5.47114 10.3235 5.54918 10.2912C5.62722 10.2589 5.69813 10.2115 5.75786 10.1518L7.5 8.40964L9.24214 10.1518C9.30187 10.2115 9.37278 10.2589 9.45082 10.2912C9.52886 10.3235 9.6125 10.3402 9.69696 10.3402C9.78143 10.3402 9.86507 10.3235 9.94311 10.2912C10.0212 10.2589 10.0921 10.2115 10.1518 10.1518C10.2115 10.0921 10.2589 10.0212 10.2912 9.94311C10.3235 9.86507 10.3402 9.78143 10.3402 9.69696C10.3402 9.6125 10.3235 9.52886 10.2912 9.45082C10.2589 9.37278 10.2115 9.30187 10.1518 9.24214L8.40964 7.5L10.1518 5.75786C10.2115 5.69813 10.2589 5.62722 10.2912 5.54918C10.3235 5.47114 10.3402 5.3875 10.3402 5.30304C10.3402 5.21857 10.3235 5.13493 10.2912 5.05689C10.2589 4.97885 10.2115 4.90794 10.1518 4.84821C10.0921 4.78849 10.0212 4.74111 9.94311 4.70878C9.86507 4.67646 9.78143 4.65982 9.69696 4.65982C9.6125 4.65982 9.52886 4.67646 9.45082 4.70878C9.37278 4.74111 9.30187 4.78849 9.24214 4.84821L7.5 6.59036Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2775_147469">
        <rect width="15" height="15" rx="7.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FilledRemoveCircleInnerWhite = (_props: T) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <g clipPath="url(#clip0_2775_148093)">
      <rect width="15" height="15" rx="7.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 0H1.66667C0.75 0 0 0.75 0 1.66667V13.3333C0 14.25 0.75 15 1.66667 15H13.3333C14.25 15 15 14.25 15 13.3333V1.66667C15 0.75 14.25 0 13.3333 0ZM10.8333 8.33333H4.16667C3.70833 8.33333 3.33333 7.95833 3.33333 7.5C3.33333 7.04167 3.70833 6.66667 4.16667 6.66667H10.8333C11.2917 6.66667 11.6667 7.04167 11.6667 7.5C11.6667 7.95833 11.2917 8.33333 10.8333 8.33333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2775_148093">
        <rect width="15" height="15" rx="7.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FilledCommunityIcon = (_props: T) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <path
      d="M7.28578 8.14244C8.13827 8.14244 8.95583 7.80379 9.55863 7.201C10.1614 6.5982 10.5001 5.78063 10.5001 4.92815C10.5001 4.07567 10.1614 3.25811 9.55863 2.65531C8.95583 2.05251 8.13827 1.71387 7.28578 1.71387C6.4333 1.71387 5.61574 2.05251 5.01294 2.65531C4.41015 3.25811 4.0715 4.07567 4.0715 4.92815C4.0715 5.78063 4.41015 6.5982 5.01294 7.201C5.61574 7.80379 6.4333 8.14244 7.28578 8.14244ZM1.71436 11.127C1.71436 10.1884 2.47464 9.42815 3.41321 9.42815H8.21321C7.83756 10.3759 7.83114 11.4301 8.19522 12.3823C8.5593 13.3346 9.26738 14.1156 10.1795 14.571H8.12836C7.62181 14.571 7.1267 14.7215 6.70582 15.0034C6.28494 15.2853 5.95726 15.6858 5.76436 16.1542C4.04578 15.8362 3.0155 14.9782 2.42664 14.0199C1.71436 12.8653 1.71436 11.6722 1.71436 11.4664V11.127ZM13.8198 14.571H15.8726C16.9398 14.571 17.8544 15.225 18.2366 16.1542C19.9552 15.8362 20.9855 14.9782 21.5744 14.0199C22.2858 12.8644 22.2858 11.6713 22.2858 11.4656V11.127C22.2858 10.6764 22.1068 10.2443 21.7882 9.92574C21.4696 9.60714 21.0375 9.42815 20.5869 9.42815H15.7869C16.1626 10.3759 16.169 11.4301 15.8049 12.3823C15.4408 13.3346 14.7328 14.1156 13.8206 14.571H13.8198ZM19.9286 4.92815C19.9286 5.78063 19.59 6.5982 18.9872 7.201C18.3844 7.80379 17.5668 8.14244 16.7144 8.14244C15.8619 8.14244 15.0443 7.80379 14.4415 7.201C13.8387 6.5982 13.5001 5.78063 13.5001 4.92815C13.5001 4.07567 13.8387 3.25811 14.4415 2.65531C15.0443 2.05251 15.8619 1.71387 16.7144 1.71387C17.5668 1.71387 18.3844 2.05251 18.9872 2.65531C19.59 3.25811 19.9286 4.07567 19.9286 4.92815ZM6.42864 17.127C6.42864 16.1884 7.18893 15.4282 8.1275 15.4282H15.8726C16.8112 15.4282 17.5715 16.1884 17.5715 17.127V17.4656C17.5715 17.6713 17.5715 18.8644 16.8601 20.0199C16.1144 21.2336 14.6624 22.2853 12.0001 22.2853C9.33778 22.2853 7.88578 21.2327 7.14007 20.0207C6.42864 18.8644 6.42864 17.6722 6.42864 17.4656V17.127ZM12.0001 14.1424C12.8526 14.1424 13.6701 13.8038 14.2729 13.201C14.8757 12.5982 15.2144 11.7806 15.2144 10.9282C15.2144 10.0757 14.8757 9.25811 14.2729 8.65531C13.6701 8.05251 12.8526 7.71387 12.0001 7.71387C11.1476 7.71387 10.33 8.05251 9.72723 8.65531C9.12443 9.25811 8.78578 10.0757 8.78578 10.9282C8.78578 11.7806 9.12443 12.5982 9.72723 13.201C10.33 13.8038 11.1476 14.1424 12.0001 14.1424Z"
      fill="currentColor"
    />
  </svg>
);

/** This may not icon in design system */
export const FilledMailIcon = (_props: T) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <circle cx="10.5" cy="10" r="10" fill="#009CE0" />
    <path
      d="M15.2866 5.81567H6.26274C5.64236 5.81567 5.14041 6.33307 5.14041 6.96545L5.13477 13.8641C5.13477 14.4965 5.64236 15.0139 6.26274 15.0139H15.2866C15.907 15.0139 16.4146 14.4965 16.4146 13.8641V6.96545C16.4146 6.33307 15.907 5.81567 15.2866 5.81567ZM15.2866 13.8641H6.26274V8.11523L10.7747 10.9897L15.2866 8.11523V13.8641ZM10.7747 9.8399L6.26274 6.96545H15.2866L10.7747 9.8399Z"
      fill="#FBFBFB"
    />
  </svg>
);

export const FilledPhoneIcon = (_props: T) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <circle cx="10.5" cy="10" r="10" fill="#009CE0" />
    <path
      d="M6.65685 5H8.97056L10.1274 7.89213L8.68135 8.75977C9.30082 10.0158 10.3174 11.0324 11.5735 11.6519L12.4411 10.2058L15.3333 11.3627V13.6764C15.3333 13.9832 15.2114 14.2775 14.9944 14.4944C14.7775 14.7114 14.4832 14.8333 14.1764 14.8333C11.9201 14.6961 9.79201 13.738 8.19363 12.1396C6.59525 10.5412 5.63712 8.41314 5.5 6.15685C5.5 5.85004 5.62188 5.55579 5.83883 5.33883C6.05579 5.12188 6.35004 5 6.65685 5Z"
      fill="white"
    />
  </svg>
);

export const FilledSaveIcon = (_props: T) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <path
      d="M17.9357 4.50001L13.8751 0.439551C13.7362 0.299756 13.5709 0.188923 13.3888 0.113473C13.2067 0.0380222 13.0115 -0.000544959 12.8144 5.81692e-06H7.12496L7.125 0.000921702V4.50092H12.375C12.5739 4.50092 12.7647 4.57994 12.9053 4.72059C13.046 4.86124 13.125 5.05201 13.125 5.25092C13.125 5.44983 13.046 5.6406 12.9053 5.78125C12.7647 5.9219 12.5739 6.00092 12.375 6.00092H6.375C6.17609 6.00091 5.98533 5.92189 5.84468 5.78124C5.70403 5.64059 5.62501 5.44983 5.625 5.25092V0.000921702L5.62505 5.81692e-06H1.875C1.47731 0.000460634 1.09605 0.158642 0.814842 0.439848C0.533636 0.721054 0.375455 1.10232 0.375 1.50001V16.5C0.375455 16.8977 0.533636 17.279 0.814842 17.5602C1.09605 17.8414 1.47731 17.9996 1.875 18H16.875C17.2727 17.9996 17.654 17.8414 17.9352 17.5602C18.2164 17.279 18.3745 16.8977 18.375 16.5V5.56074C18.3755 5.36367 18.337 5.16845 18.2616 4.98638C18.1862 4.8043 18.0754 4.63899 17.9357 4.50001ZM9.375 13.875C8.92999 13.875 8.49498 13.7431 8.12497 13.4958C7.75496 13.2486 7.46657 12.8972 7.29627 12.4861C7.12597 12.0749 7.08142 11.6225 7.16823 11.1861C7.25505 10.7496 7.46934 10.3487 7.78401 10.034C8.09868 9.71938 8.49959 9.50509 8.93605 9.41827C9.3725 9.33146 9.8249 9.37601 10.236 9.54631C10.6472 9.71661 10.9986 10.005 11.2458 10.375C11.493 10.745 11.625 11.18 11.625 11.625C11.6243 12.2216 11.3871 12.7935 10.9653 13.2153C10.5434 13.6371 9.97153 13.8744 9.375 13.875Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledShareIcon = (_props: T) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <path
      d="M13.75 13.1899C13.3331 13.1898 12.9203 13.2733 12.5363 13.4356C12.1523 13.5979 11.8047 13.8356 11.5142 14.1347L7.91284 11.8195C8.19568 11.093 8.19568 10.2869 7.91284 9.56037L11.5142 7.24519C12.0548 7.79822 12.7815 8.13083 13.5534 8.17856C14.3253 8.22628 15.0875 7.98572 15.6921 7.5035C16.2967 7.02128 16.7008 6.33175 16.8259 5.56857C16.9511 4.80538 16.7885 4.02291 16.3695 3.37282C15.9506 2.72274 15.3053 2.25134 14.5585 2.05C13.8118 1.84867 13.017 1.93174 12.328 2.28311C11.6391 2.63449 11.1051 3.22914 10.8297 3.95179C10.5542 4.67445 10.5568 5.47364 10.8371 6.19445L7.23569 8.50965C6.80201 8.06435 6.24539 7.75849 5.63698 7.63119C5.02857 7.50388 4.39601 7.5609 3.82018 7.79497C3.24435 8.02904 2.7514 8.42952 2.40436 8.9452C2.05732 9.46089 1.87195 10.0684 1.87195 10.6899C1.87195 11.3115 2.05732 11.919 2.40436 12.4347C2.7514 12.9504 3.24435 13.3508 3.82018 13.5849C4.39601 13.819 5.02857 13.876 5.63698 13.7487C6.24539 13.6214 6.80201 13.3155 7.23569 12.8702L10.8371 15.1854C10.596 15.8076 10.5604 16.4906 10.7355 17.1345C10.9107 17.7784 11.2873 18.3493 11.8104 18.7636C12.3334 19.1779 12.9754 19.4139 13.6422 19.437C14.3091 19.4602 14.9658 19.2692 15.5163 18.8921C16.0668 18.515 16.4821 17.9715 16.7014 17.3413C16.9207 16.7111 16.9325 16.0273 16.7351 15.3899C16.5376 14.7525 16.1413 14.1951 15.6042 13.7992C15.067 13.4033 14.4172 13.1898 13.75 13.1899Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledRefreshCircle = (_props: T) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {..._props}
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM6.6 11.23C6.77 10.04 7.3 8.97 8.13 8.13C10.13 6.14 13.28 6.03 15.42 7.77V6.82C15.42 6.41 15.76 6.07 16.17 6.07C16.58 6.07 16.92 6.41 16.92 6.82V9.49C16.92 9.9 16.58 10.24 16.17 10.24H13.5C13.09 10.24 12.75 9.9 12.75 9.49C12.75 9.08 13.09 8.74 13.5 8.74H14.25C12.7 7.66 10.56 7.81 9.18 9.19C8.58 9.79 8.2 10.57 8.07 11.44C8.02 11.81 7.7 12.08 7.33 12.08C7.29 12.08 7.26 12.08 7.22 12.07C6.83 12.02 6.54 11.64 6.6 11.23ZM15.87 15.87C14.8 16.94 13.4 17.47 12 17.47C10.78 17.47 9.57 17.04 8.57 16.23V17.17C8.57 17.58 8.23 17.92 7.82 17.92C7.41 17.92 7.07 17.58 7.07 17.17V14.5C7.07 14.09 7.41 13.75 7.82 13.75H10.49C10.9 13.75 11.24 14.09 11.24 14.5C11.24 14.91 10.9 15.25 10.49 15.25H9.74C11.29 16.33 13.43 16.18 14.81 14.8C15.41 14.2 15.79 13.42 15.92 12.55C15.98 12.14 16.35 11.85 16.77 11.91C17.18 11.97 17.46 12.35 17.41 12.76C17.23 13.97 16.7 15.04 15.87 15.87Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledLockIcon = (props: T) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 21.6904C3.45 21.6904 2.979 21.4944 2.587 21.1024C2.195 20.7104 1.99934 20.2398 2 19.6904V9.69043C2 9.14043 2.196 8.66943 2.588 8.27743C2.98 7.88543 3.45067 7.68976 4 7.69043H5V5.69043C5 4.3071 5.48767 3.12776 6.463 2.15243C7.43834 1.1771 8.61734 0.689764 10 0.69043C11.3833 0.69043 12.5627 1.1781 13.538 2.15343C14.5133 3.12876 15.0007 4.30776 15 5.69043V7.69043H16C16.55 7.69043 17.021 7.88643 17.413 8.27843C17.805 8.67043 18.0007 9.1411 18 9.69043V19.6904C18 20.2404 17.804 20.7114 17.412 21.1034C17.02 21.4954 16.5493 21.6911 16 21.6904H4ZM10 16.6904C10.55 16.6904 11.021 16.4944 11.413 16.1024C11.805 15.7104 12.0007 15.2398 12 14.6904C12 14.1404 11.804 13.6694 11.412 13.2774C11.02 12.8854 10.5493 12.6898 10 12.6904C9.45 12.6904 8.979 12.8864 8.587 13.2784C8.195 13.6704 7.99934 14.1411 8 14.6904C8 15.2404 8.196 15.7114 8.588 16.1034C8.98 16.4954 9.45067 16.6911 10 16.6904ZM7 7.69043H13V5.69043C13 4.8571 12.7083 4.14876 12.125 3.56543C11.5417 2.9821 10.8333 2.69043 10 2.69043C9.16667 2.69043 8.45834 2.9821 7.875 3.56543C7.29167 4.14876 7 4.8571 7 5.69043V7.69043Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledGlobeIcon = (props: T) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.65006 20.9098C7.62006 20.9098 7.58006 20.9298 7.55006 20.9298C5.61006 19.9698 4.03006 18.3798 3.06006 16.4398C3.06006 16.4098 3.08006 16.3698 3.08006 16.3398C4.30006 16.6998 5.56006 16.9698 6.81006 17.1798C7.03006 18.4398 7.29006 19.6898 7.65006 20.9098Z"
      fill="currentColor"
    />
    <path
      d="M20.94 16.4498C19.95 18.4398 18.3 20.0498 16.29 21.0198C16.67 19.7498 16.99 18.4698 17.2 17.1798C18.46 16.9698 19.7 16.6998 20.92 16.3398C20.91 16.3798 20.94 16.4198 20.94 16.4498Z"
      fill="currentColor"
    />
    <path
      d="M21.02 7.71047C19.76 7.33047 18.49 7.02047 17.2 6.80047C16.99 5.51047 16.68 4.23047 16.29 2.98047C18.36 3.97047 20.03 5.64047 21.02 7.71047Z"
      fill="currentColor"
    />
    <path
      d="M7.64998 3.09055C7.28998 4.31055 7.02998 5.55055 6.81998 6.81055C5.52998 7.01055 4.24998 7.33055 2.97998 7.71055C3.94998 5.70055 5.55998 4.05055 7.54998 3.06055C7.57998 3.06055 7.61998 3.09055 7.64998 3.09055Z"
      fill="currentColor"
    />
    <path
      d="M15.4898 6.59C13.1698 6.33 10.8298 6.33 8.50977 6.59C8.75977 5.22 9.07977 3.85 9.52977 2.53C9.54977 2.45 9.53977 2.39 9.54977 2.31C10.3398 2.12 11.1498 2 11.9998 2C12.8398 2 13.6598 2.12 14.4398 2.31C14.4498 2.39 14.4498 2.45 14.4698 2.53C14.9198 3.86 15.2398 5.22 15.4898 6.59Z"
      fill="currentColor"
    />
    <path
      d="M6.59 15.4898C5.21 15.2398 3.85 14.9198 2.53 14.4698C2.45 14.4498 2.39 14.4598 2.31 14.4498C2.12 13.6598 2 12.8498 2 11.9998C2 11.1598 2.12 10.3398 2.31 9.55977C2.39 9.54977 2.45 9.54977 2.53 9.52977C3.86 9.08977 5.21 8.75977 6.59 8.50977C6.34 10.8298 6.34 13.1698 6.59 15.4898Z"
      fill="currentColor"
    />
    <path
      d="M22.0002 11.9998C22.0002 12.8498 21.8802 13.6598 21.6902 14.4498C21.6102 14.4598 21.5502 14.4498 21.4702 14.4698C20.1402 14.9098 18.7802 15.2398 17.4102 15.4898C17.6702 13.1698 17.6702 10.8298 17.4102 8.50977C18.7802 8.75977 20.1502 9.07977 21.4702 9.52977C21.5502 9.54977 21.6102 9.55977 21.6902 9.55977C21.8802 10.3498 22.0002 11.1598 22.0002 11.9998Z"
      fill="currentColor"
    />
    <path
      d="M15.4898 17.4102C15.2398 18.7902 14.9198 20.1502 14.4698 21.4702C14.4498 21.5502 14.4498 21.6102 14.4398 21.6902C13.6598 21.8802 12.8398 22.0002 11.9998 22.0002C11.1498 22.0002 10.3398 21.8802 9.54977 21.6902C9.53977 21.6102 9.54977 21.5502 9.52977 21.4702C9.08977 20.1402 8.75977 18.7902 8.50977 17.4102C9.66977 17.5402 10.8298 17.6302 11.9998 17.6302C13.1698 17.6302 14.3398 17.5402 15.4898 17.4102Z"
      fill="currentColor"
    />
    <path
      d="M15.7633 15.7633C13.2622 16.0789 10.7378 16.0789 8.23667 15.7633C7.92111 13.2622 7.92111 10.7378 8.23667 8.23667C10.7378 7.92111 13.2622 7.92111 15.7633 8.23667C16.0789 10.7378 16.0789 13.2622 15.7633 15.7633Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledProfileTwoUsersIcon = (props: T) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 3C7.01789 3 5 5.02002 5 7.50474C5 9.94204 6.90421 11.9146 9.38632 12C9.46211 11.9905 9.5379 11.9905 9.59474 12C9.61368 12 9.62316 12 9.64211 12C9.65158 12 9.65158 12 9.66105 12C12.0863 11.9146 13.9905 9.94204 14 7.50474C14 5.02002 11.9821 3 9.5 3Z"
      fill="currentColor"
    />
    <path
      d="M14.1903 14.2071C11.6143 12.5976 7.41335 12.5976 4.81889 14.2071C3.64631 14.9427 3 15.9378 3 17.0022C3 18.0665 3.64631 19.053 4.80966 19.7799C6.10227 20.5933 7.80114 21 9.5 21C11.1989 21 12.8977 20.5933 14.1903 19.7799C15.3537 19.0443 16 18.0579 16 16.9849C15.9908 15.9205 15.3537 14.934 14.1903 14.2071Z"
      fill="currentColor"
    />
    <path
      d="M18.9893 7.74433C19.1251 9.3658 17.9541 10.7867 16.3334 10.9789C16.3249 10.9789 16.3249 10.9789 16.3165 10.9789H16.291C16.2401 10.9789 16.1892 10.9789 16.1468 10.9956C15.3237 11.0374 14.5685 10.7783 14 10.3019C14.874 9.53296 15.3746 8.37955 15.2728 7.12584C15.2134 6.44884 14.9758 5.83034 14.6194 5.30378C14.9419 5.14498 15.3152 5.04468 15.697 5.01125C17.3601 4.86916 18.845 6.08944 18.9893 7.74433Z"
      fill="currentColor"
    />
    <path
      d="M20.9905 15.9479C20.9206 16.8841 20.3788 17.6948 19.47 18.2449C18.5962 18.7758 17.4952 19.0267 16.403 18.9978C17.0321 18.3704 17.3991 17.5886 17.469 16.7586C17.5564 15.5618 17.0409 14.4133 16.0098 13.4964C15.4243 12.9848 14.7427 12.5795 14 12.2803C15.9311 11.6626 18.3603 12.0776 19.8545 13.4095C20.6584 14.1237 21.0691 15.0213 20.9905 15.9479Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledWarning2Icon = (props: T) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.5099 5.85L13.5699 2.42C12.5999 1.86 11.3999 1.86 10.4199 2.42L4.48992 5.85C3.51992 6.41 2.91992 7.45 2.91992 8.58V15.42C2.91992 16.54 3.51992 17.58 4.48992 18.15L10.4299 21.58C11.3999 22.14 12.5999 22.14 13.5799 21.58L19.5199 18.15C20.4899 17.59 21.0899 16.55 21.0899 15.42V8.58C21.0799 7.45 20.4799 6.42 19.5099 5.85ZM11.2499 7.75C11.2499 7.34 11.5899 7 11.9999 7C12.4099 7 12.7499 7.34 12.7499 7.75V13C12.7499 13.41 12.4099 13.75 11.9999 13.75C11.5899 13.75 11.2499 13.41 11.2499 13V7.75ZM12.9199 16.63C12.8699 16.75 12.7999 16.86 12.7099 16.96C12.5199 17.15 12.2699 17.25 11.9999 17.25C11.8699 17.25 11.7399 17.22 11.6199 17.17C11.4899 17.12 11.3899 17.05 11.2899 16.96C11.1999 16.86 11.1299 16.75 11.0699 16.63C11.0199 16.51 10.9999 16.38 10.9999 16.25C10.9999 15.99 11.0999 15.73 11.2899 15.54C11.3899 15.45 11.4899 15.38 11.6199 15.33C11.9899 15.17 12.4299 15.26 12.7099 15.54C12.7999 15.64 12.8699 15.74 12.9199 15.87C12.9699 15.99 12.9999 16.12 12.9999 16.25C12.9999 16.38 12.9699 16.51 12.9199 16.63Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledCameraIcon = (props: T) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 10.625C12 11.7296 11.1046 12.625 10 12.625C8.89543 12.625 8 11.7296 8 10.625C8 9.52043 8.89543 8.625 10 8.625C11.1046 8.625 12 9.52043 12 10.625Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M17.8125 5.625H14.5703C14.4531 5.625 14.3078 5.54922 14.1945 5.42969L13.1289 3.75781C12.6953 3.125 12.5 3.125 11.7969 3.125H8.20312C7.5 3.125 7.26562 3.125 6.87227 3.7582L5.80547 5.42969C5.71875 5.52422 5.59688 5.625 5.46875 5.625V5C5.46875 4.91712 5.43583 4.83763 5.37722 4.77903C5.31862 4.72042 5.23913 4.6875 5.15625 4.6875H3.59375C3.51087 4.6875 3.43138 4.72042 3.37278 4.77903C3.31417 4.83763 3.28125 4.91712 3.28125 5V5.625H2.1875C1.93886 5.625 1.7004 5.72377 1.52459 5.89959C1.34877 6.0754 1.25 6.31386 1.25 6.5625V15.9375C1.25 16.1861 1.34877 16.4246 1.52459 16.6004C1.7004 16.7762 1.93886 16.875 2.1875 16.875H17.8125C18.0611 16.875 18.2996 16.7762 18.4754 16.6004C18.6512 16.4246 18.75 16.1861 18.75 15.9375V6.5625C18.75 6.31386 18.6512 6.0754 18.4754 5.89959C18.2996 5.72377 18.0611 5.625 17.8125 5.625ZM10.1762 14.3711C9.42033 14.4066 8.67142 14.2126 8.02787 13.8146C7.38431 13.4166 6.8762 12.8333 6.57031 12.1412C6.26441 11.4491 6.17505 10.6807 6.31395 9.93684C6.45285 9.19302 6.81352 8.50862 7.34857 7.97357C7.88362 7.43852 8.56802 7.07785 9.31184 6.93895C10.0557 6.80005 10.8241 6.88941 11.5162 7.19531C12.2083 7.5012 12.7916 8.00931 13.1896 8.65287C13.5876 9.29642 13.7816 10.0453 13.7461 10.8012C13.7013 11.7335 13.3108 12.6158 12.6508 13.2758C11.9908 13.9358 11.1085 14.3263 10.1762 14.3711Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledMenuIcon = (props: T) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M17.5401 8.80965C19.1748 8.80965 20.5001 7.48441 20.5001 5.84965C20.5001 4.21489 19.1748 2.88965 17.5401 2.88965C15.9053 2.88965 14.5801 4.21489 14.5801 5.84965C14.5801 7.48441 15.9053 8.80965 17.5401 8.80965Z"
      fill="currentColor"
    />
    <path
      d="M6.46 8.80965C8.09476 8.80965 9.42 7.48441 9.42 5.84965C9.42 4.21489 8.09476 2.88965 6.46 2.88965C4.82524 2.88965 3.5 4.21489 3.5 5.84965C3.5 7.48441 4.82524 8.80965 6.46 8.80965Z"
      fill="currentColor"
    />
    <path
      d="M17.5401 21.1104C19.1748 21.1104 20.5001 19.7852 20.5001 18.1504C20.5001 16.5157 19.1748 15.1904 17.5401 15.1904C15.9053 15.1904 14.5801 16.5157 14.5801 18.1504C14.5801 19.7852 15.9053 21.1104 17.5401 21.1104Z"
      fill="currentColor"
    />
    <path
      d="M6.46 21.1104C8.09476 21.1104 9.42 19.7852 9.42 18.1504C9.42 16.5157 8.09476 15.1904 6.46 15.1904C4.82524 15.1904 3.5 16.5157 3.5 18.1504C3.5 19.7852 4.82524 21.1104 6.46 21.1104Z"
      fill="currentColor"
    />
  </svg>
);

export const FiiledShoppingCard = (props: T) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M3.59641 4.19473C3.59641 4.0356 3.65963 3.88298 3.77215 3.77046C3.88467 3.65794 4.03728 3.59473 4.19641 3.59473H4.72201C5.59441 3.59473 6.09602 4.16233 6.38642 4.72873C6.58442 5.11633 6.72722 5.58913 6.84602 5.99953H19.2C19.3854 5.99958 19.5683 6.0426 19.7343 6.12522C19.9003 6.20783 20.0449 6.32779 20.1568 6.47568C20.2686 6.62357 20.3447 6.79536 20.379 6.97759C20.4133 7.15981 20.4049 7.3475 20.3544 7.52593L18.5592 13.8559C18.4164 14.3581 18.1137 14.8001 17.6971 15.1147C17.2804 15.4294 16.7725 15.5996 16.2504 15.5995H10.1556C9.62915 15.5997 9.11722 15.4268 8.69872 15.1074C8.28021 14.788 7.97834 14.3398 7.83962 13.8319L7.06922 11.0059C7.0648 10.9933 7.0608 10.9805 7.05722 10.9675L5.82001 6.77113L5.70002 6.36673C5.58002 5.95153 5.47441 5.58433 5.31601 5.27593C5.12521 4.90393 4.95001 4.79593 4.72081 4.79593H4.19521C4.03609 4.79593 3.88347 4.73271 3.77095 4.62019C3.65843 4.50767 3.59521 4.35506 3.59521 4.19593L3.59641 4.19473ZM10.2 20.3995C10.6774 20.3995 11.1352 20.2099 11.4728 19.8723C11.8104 19.5348 12 19.0769 12 18.5995C12 18.1221 11.8104 17.6643 11.4728 17.3267C11.1352 16.9892 10.6774 16.7995 10.2 16.7995C9.72263 16.7995 9.26479 16.9892 8.92722 17.3267C8.58966 17.6643 8.40002 18.1221 8.40002 18.5995C8.40002 19.0769 8.58966 19.5348 8.92722 19.8723C9.26479 20.2099 9.72263 20.3995 10.2 20.3995ZM16.2 20.3995C16.6774 20.3995 17.1352 20.2099 17.4728 19.8723C17.8104 19.5348 18 19.0769 18 18.5995C18 18.1221 17.8104 17.6643 17.4728 17.3267C17.1352 16.9892 16.6774 16.7995 16.2 16.7995C15.7226 16.7995 15.2648 16.9892 14.9272 17.3267C14.5897 17.6643 14.4 18.1221 14.4 18.5995C14.4 19.0769 14.5897 19.5348 14.9272 19.8723C15.2648 20.2099 15.7226 20.3995 16.2 20.3995Z"
      fill="currentColor"
    />
  </svg>
);
